import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/lib/integration/react";
import configureStore from "./redux/store";
import "./index.css";

import "../src/fonts/rotobo/Roboto-Light.ttf";
import "../src/fonts/rotobo/Roboto-Regular.ttf";
import "../src/fonts/rotobo/Roboto-Medium.ttf";
import "../src/fonts/rotobo/Roboto-Bold.ttf";

import "../src/fonts/opensans/OpenSans-Regular.ttf";
import "../src/fonts/opensans/OpenSans-Medium.ttf";
import "../src/fonts/opensans/OpenSans-Bold.ttf";

let { store, persistor } = configureStore();
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
